<template>
  <q-dialog v-model="shown">
    <q-card style="width: 530px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Adjust Points
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <q-input
          v-model="user.newPointsBalance"
          label="New Points Balance"
          type="number"
          min="0"
          bottom-slots
        />
        <iso-date-input
          v-model="user.newPointsExpiresAt"
          label="New Points Expiry Date"
          clearable
        />
        <q-inner-loading :showing="saving" />
      </q-card-section>
      <q-card-actions class="row justify-between q-ma-sm">
        <q-btn
          v-show="!saving"
          class="col"
          label="Update Points"
          color="primary"
          size="lg"
          :disable="user.newPointsBalance === user.points"
          @click="save"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

import IsoDateInput from 'src/modules/admin/components/IsoDateInput'

export default {
  name: 'UserPointsDialog',
  components: {
    IsoDateInput
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['close'],
  data () {
    return {
      shown: false,
      saving: false
    }
  },
  watch: {
    shown () {
      if (!this.shown) {
        this.$emit('close')
        this.user.resetField('newPointsBalance')
        this.user.resetField('newPointsExpiresAt')
      }
    }
  },
  methods: {
    async show () {
      this.user.newPointsBalance = this.user.points
      this.shown = true
    },
    async save () {
      this.saving = true
      await this.user.editPoints()
      this.saving = false
      this.shown = false
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
